import { render, staticRenderFns } from "./HeaderUserLoginFb.vue?vue&type=template&id=2a926900"
import script from "./HeaderUserLoginFb.vue?vue&type=script&lang=ts"
export * from "./HeaderUserLoginFb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports